$(document).ready(function () {

    $('body').on('click', function (e) {
        if ($(e.target).closest('.js-team-member').length < 1) {
            $('.js-team-popup').removeClass('visible');
        }
    });

    $('.js-team-member').on('click', function (event) {

        // Find the popup within the clicked element
        var $popup = $(this).find('.js-team-popup');

        // Remove the visible class from all popups
        $('.js-team-popup').not($popup).removeClass('visible');

       /* // Get the click coordinates relative to the js-team-member
        var offset = $(this).offset();
        var relativeX = event.pageX - offset.left;
        var relativeY = event.pageY - offset.top;

        // Set the position of the popup relative to the js-team-member
        $popup.css({
            'position': 'absolute',
            'top': relativeY + 'px',
            'left': relativeX + 'px'
        });*/

        // Add the visible class to the popup
        $popup.toggleClass('visible');
    });

});